import React from 'react';
import './App.css';
import './config';
import { AuthContext, useAuth } from './context/AuthContext';
import { I18nProvider } from './context/I18nContext';
import LoadingSpinner from './components/LoadingSpinner';
import AuthComponent from './components/AuthComponent';
import Dashboard from './components/Dashboard';
import BetaBanner from './components/BetaBanner';
import BetaFooter from './components/BetaFooter';
import { TermsBeta, Privacy } from './components/LegalPages';
import ForgotPasswordPage from './components/ForgotPasswordPage';
import OnboardingRequestPage from './components/OnboardingRequestPage';
import LandingPage from './components/LandingPage';
import SetPasswordPage from './components/SetPasswordPage';
import CheckoutStatusPage from './components/CheckoutStatusPage';
import StewardCommandCenter from './components/StewardCommandCenter';

function App() {
  const { user, login, register, logout, loading } = useAuth();
  const path = typeof window !== 'undefined' ? window.location.pathname : '/';

  // Paginas legales publicas (sin auth, sin app shell)
  if (path === '/terms-beta') {
    return (
      <I18nProvider>
        <TermsBeta />
      </I18nProvider>
    );
  }
  if (path === '/privacy') {
    return (
      <I18nProvider>
        <Privacy />
      </I18nProvider>
    );
  }
  if (path === '/forgot-password') {
    return (
      <I18nProvider>
        <ForgotPasswordPage />
      </I18nProvider>
    );
  }
  if (path === '/set-password') {
    return (
      <I18nProvider>
        <SetPasswordPage />
      </I18nProvider>
    );
  }
  if (path === '/onboarding' || path === '/beta') {
    return (
      <I18nProvider>
        <OnboardingRequestPage />
      </I18nProvider>
    );
  }
  // F4 §14: páginas de retorno post-Stripe Flow A.
  if (path === '/checkout/success') {
    return (
      <I18nProvider>
        <CheckoutStatusPage mode="success" />
      </I18nProvider>
    );
  }
  if (path === '/checkout/cancel') {
    return (
      <I18nProvider>
        <CheckoutStatusPage mode="cancel" />
      </I18nProvider>
    );
  }

  if (loading) {
    return <LoadingSpinner />;
  }

  // JRS Fase D: Centro de Comando del Soberano.
  // Requiere sesión autenticada. La app muestra AuthComponent si no hay user.
  if (path === '/admin/steward') {
    if (!user) {
      return (
        <I18nProvider>
          <AuthContext.Provider value={{ user, login, register, logout }}>
            <div className="App">
              <BetaBanner />
              <div className="pt-9">
                <AuthComponent onLogin={login} onRegister={register} />
              </div>
              <BetaFooter />
            </div>
          </AuthContext.Provider>
        </I18nProvider>
      );
    }
    return (
      <I18nProvider>
        <AuthContext.Provider value={{ user, login, register, logout }}>
          <div className="App min-h-screen bg-background">
            <BetaBanner />
            <div className="pt-9">
              <StewardCommandCenter
                user={user}
                onExit={() => { window.location.href = '/'; }}
              />
            </div>
            <BetaFooter />
          </div>
        </AuthContext.Provider>
      </I18nProvider>
    );
  }

  // Landing publica si no hay sesion y estamos en la raiz
  if (!user && path === '/') {
    return (
      <I18nProvider>
        <LandingPage />
      </I18nProvider>
    );
  }

  return (
    <I18nProvider>
      <AuthContext.Provider value={{ user, login, register, logout }}>
        <div className="App">
          <BetaBanner />
          <div className="pt-9">
            {user ? (
              <Dashboard user={user} onLogout={logout} />
            ) : (
              <AuthComponent onLogin={login} onRegister={register} />
            )}
          </div>
          <BetaFooter />
        </div>
      </AuthContext.Provider>
    </I18nProvider>
  );
}

export default App;
